import { ApiConfig } from "../../../Api/Api";

export const getSubjectDataApi = async () => {
  return await ApiConfig.get(`api/v2/subject`);
};
